module.exports = __webpack_public_path__ + "img/_licht.df316825.svg";